import React from 'react';
import ReservationRuleDetailsPopover from './ReservationRuleDetailsPopover';

const ReservationRuleOptionLabel = ({ rule }) => (
  <div className="reservation-rule-option">
    <span className="reservation-rule-option-name">{rule?.name || '-'}</span>
    <ReservationRuleDetailsPopover rule={rule} />
  </div>
);

export default ReservationRuleOptionLabel;
